import {
  IDigitalDeliveryForm,
  IDigitalDeliveryResponse,
  DELIVERY_METHOD
} from 'services/digital-delivery/types';
import { IMusicProductDigitalDeliveryServiceResponse } from 'services/music-product-digital/types/query';

export const digitalDeliveryQueryToForm = (
  query: IDigitalDeliveryResponse
): IDigitalDeliveryForm => {
  const { ...delivery } = {
    ...query,
    included: query.included.map(d => ({
      ...d,
      publishTime: d.publishTime.slice(0, 5),
    })),
    excluded: query.excluded.map(d => ({
      ...d,
      publishTime: d.publishTime.slice(0, 5),
    })),
  };

  return delivery;
};

export const digitalDeliveryServiceQueryToForm = (
  service: IMusicProductDigitalDeliveryServiceResponse
): IDigitalDeliveryForm => {
  const { deliveryStatus, logoImageUrl, ...delivery } = {
    ...service,
    included: [],
    excluded: [],
    salesChannelLogo: service.logoImageUrl,
    status: service.deliveryStatus,
    priority: false,
    version: 0,
    id: '00000000-0000-0000-0000-000000000000',
    deliveryType: service.deliveryMethod as unknown as DELIVERY_METHOD
  };

  return delivery;
};
